module.exports = __webpack_public_path__ + "static/media/setup_mail.fa832e7c.webp";